export default __webpack_public_path__ + "static/project-slide-5-768-700-c3ef8093d4c5c2aaa68230ee3222881a.jpg";